<template>
  <div class="dashboard dashboard-v2">
    <div class="container">
      <KitVersionToggle v-if="component === 0" activeVersion="v2" />
      <StateV2
        v-if="showdashboard && component === 0"
        @switchOrder="switchOrderV2"
        @showoutlinerkits="showoutlinerkitsV2"
        @clearOutlier="clearOutlierV2"
      ></StateV2>
      <BreadcrumbV2 v-if="component === 0" :breadcrumbs="breadcrumbItemsV2" />
      <FiltersV2
        v-if="component === 0"
        @showTestKitModalV2="showTestKitModalV2"
        @clearOutlier="clearOutlierV2"
      ></FiltersV2>
      <KitsV2
        @showModal="showModalV2"
        v-if="component === 0"
        @showComment="showComment"
        @confurmDelKit="confurmDelKitV2"
        @confurmArvKit="confurmArvKitV2"
        @confirmUnArvKit="confirmUnArvKitV2"
        @editKit="editKit"
        @confirmCusLogin="confirmCusLoginV2"
        :activeOutlierType="activeOutlierTypeV2"
      ></KitsV2>
      <MtcLabUsers v-if="component === 22"></MtcLabUsers>
      <EditTestkitV2 v-if="showEditV2" @closeModal="closeEditingV2"></EditTestkitV2>
      <ModalV2 v-if="modalV2" @closeModal="closeModalV2"></ModalV2>
      <AddTestKitV2 v-if="showV2Kit" @closeModal="closeV2KitModal"></AddTestKitV2>
      <!-- V2 Confirmation Modals -->
      <div class="formCom" v-if="showConfirmDelete">
        <div class="confirm-form">
          <div class="confirm-title">Kit ID {{ KitInfo.kit_id }}</div>
          <div class="confirm-action">Delete?</div>
          <div class="confirm-buttons">
            <button class="confirm-btn cancel" @click="showConfirmDelete = false">Cancel</button>
            <button class="confirm-btn ok" @click="doDeleteV2">Confirm</button>
          </div>
        </div>
      </div>
      <div class="formCom" v-if="showConfirmArchive">
        <div class="confirm-form">
          <div class="confirm-title">Kit ID {{ KitInfo.kit_id }}</div>
          <div class="confirm-action">Archive?</div>
          <textarea v-model="archiveComment" placeholder="Comment (optional)" class="confirm-textarea"></textarea>
          <div class="confirm-buttons">
            <button class="confirm-btn cancel" @click="showConfirmArchive = false">Cancel</button>
            <button class="confirm-btn ok" @click="doArchiveV2">Confirm</button>
          </div>
        </div>
      </div>
      <div class="formCom" v-if="showConfirmUnArchive">
        <div class="confirm-form">
          <div class="confirm-title">Kit ID {{ KitInfo.kit_id }}</div>
          <div class="confirm-action">Unarchive?</div>
          <div class="confirm-buttons">
            <button class="confirm-btn cancel" @click="showConfirmUnArchive = false">Cancel</button>
            <button class="confirm-btn ok" @click="doUnArchiveV2">Confirm</button>
          </div>
        </div>
      </div>
      <CommentOnHold
        v-if="showCommentModal"
        @closeConfurmHoldTxt="closeConfurmHoldTxt"
        :txtOnHold="txtOnHold"
        :isV2="true"
      ></CommentOnHold>
      <ConfirmLoginToCustomer
        v-if="showConfrimCusLoginV2"
        :customerInfo="customerInfoV2"
        @closeCusLogin="closeCusLoginV2"
      ></ConfirmLoginToCustomer>
      <Alert v-if="errorMes"></Alert>
      <Loader v-if="loader"></Loader>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import StateV2 from "../admin/StateV2";
import FiltersV2 from "../admin/FiltersV2";
import KitsV2 from "../admin/KitsV2";
import BreadcrumbV2 from "../admin/BreadcrumbV2";
import ModalV2 from "../admin/ModalV2";
import AddTestKitV2 from "../admin/AddTestKitV2";
import EditTestkitV2 from "../admin/EditTestkitV2";
import MtcLabUsers from "../admin/MtcLabUsers";
import CommentOnHold from "../../components/dashboard/CommentOnHold";
import ConfirmLoginToCustomer from "../../components/dashboard/modal/ConfirmLoginToCustomer";
import Loader from "../../components/Loader.vue";
import Alert from "../../components/dashboard/modal/Alert";
import KitVersionToggle from "../../components/dashboard/KitVersionToggle";

export default {
  name: "AdminDashboardV2",
  data() {
    return {
      modalV2: false,
      showV2Kit: false,
      showEditV2: false,
      showdashboard: true,
      component: 0,
      loader: false,
      errorMes: false,
      activeOutlierTypeV2: null,
      breadcrumbItemsV2: [
        { text: "Dust Kits", link: "/dashboard-v2" },
        { text: "Management" }
      ],
      KitInfo: null,
      showConfirmDelete: false,
      showConfirmArchive: false,
      showConfirmUnArchive: false,
      archiveComment: "",
      showCommentModal: false,
      txtOnHold: "",
      showConfrimCusLoginV2: false,
      customerInfoV2: null
    };
  },
  computed: {
    ...mapGetters(["getLoaderV2", "getErrorMessageV2"])
  },
  watch: {
    getLoaderV2(val) {
      this.loader = val;
    },
    getErrorMessageV2(val) {
      this.errorMes = val;
    }
  },
  methods: {
    ...mapActions([
      "sendSearchReqV2",
      "getAdminInfoV2",
      "archiveKitV2",
      "unArchiveKitV2",
      "deleteKitV2",
      "setStatusFilterV2",
      "setOutlierV2"
    ]),
    showTestKitModalV2(boolean) {
      this.showV2Kit = boolean;
    },
    closeV2KitModal(boolean) {
      this.showV2Kit = boolean;
    },
    switchOrderV2(val) {
      this.activeOutlierTypeV2 = null;
      this.setOutlierV2(null);
      this.setStatusFilterV2([val.steps]);
      this.sendSearchReqV2();
    },
    clearOutlierV2() {
      this.activeOutlierTypeV2 = null;
      this.setOutlierV2(null);
      this.setStatusFilterV2([]);
    },
    showoutlinerkitsV2(val) {
      this.activeOutlierTypeV2 = val.value;
      this.setOutlierV2(val.value);
      this.setStatusFilterV2([val.steps]);
      this.sendSearchReqV2();
    },
    confurmDelKitV2(obj) {
      this.KitInfo = obj;
      this.showConfirmDelete = obj.show;
    },
    confurmArvKitV2(obj) {
      this.KitInfo = obj;
      this.showConfirmArchive = obj.show;
      this.archiveComment = "";
    },
    confirmUnArvKitV2(obj) {
      this.KitInfo = obj;
      this.showConfirmUnArchive = obj.show;
    },
    doDeleteV2() {
      this.deleteKitV2(this.KitInfo.id).then(() => {
        this.showConfirmDelete = false;
      });
    },
    doArchiveV2() {
      const data = {
        id: this.KitInfo.id,
        reason_archive: this.archiveComment
      };
      this.archiveKitV2(data).then(() => {
        this.showConfirmArchive = false;
      });
    },
    doUnArchiveV2() {
      const data = { id: this.KitInfo.id };
      this.unArchiveKitV2(data).then(() => {
        this.showConfirmUnArchive = false;
      });
    },
    showModalV2(boolean) {
      this.modalV2 = boolean;
    },
    closeModalV2(boolean) {
      this.modalV2 = boolean;
    },
    editKit(boolean) {
      this.showEditV2 = boolean.show;
    },
    closeEditingV2(boolean) {
      this.showEditV2 = boolean;
    },
    showComment(obj) {
      this.showCommentModal = obj.show;
      this.txtOnHold = obj;
    },
    closeConfurmHoldTxt(boolean) {
      this.showCommentModal = boolean;
    },
    confirmCusLoginV2(obj) {
      this.showConfrimCusLoginV2 = obj.show;
      this.customerInfoV2 = obj.user;
    },
    closeCusLoginV2(boolean) {
      this.showConfrimCusLoginV2 = boolean;
    }
  },
  components: {
    StateV2,
    FiltersV2,
    KitsV2,
    BreadcrumbV2,
    ModalV2,
    AddTestKitV2,
    EditTestkitV2,
    MtcLabUsers,
    CommentOnHold,
    ConfirmLoginToCustomer,
    Loader,
    Alert,
    KitVersionToggle
  },
  mounted() {
    this.getAdminInfoV2();
  }
};
</script>

<style scoped>
.dashboard {
  padding: 110px 0 10px 0;
  background-color: #e6ecf0;
  max-width: 100%;
  width: 100vw;
  min-height: 95vh;
  position: relative;
}
/* Confirmation Modals */
.formCom {
  background-color: rgba(219, 230, 241, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  z-index: 99;
}
.confirm-form {
  padding: 30px;
  background-color: #fff;
  max-width: 350px;
  width: 100%;
  border-radius: 8px;
  text-align: center;
}
.confirm-title {
  color: #005eb8;
  font-size: 20px;
  margin-bottom: 8px;
  font-family: TTNormsMedium, sans-serif;
}
.confirm-action {
  color: #333;
  font-size: 18px;
  margin-bottom: 15px;
  font-family: TTNormsMedium, sans-serif;
}
.confirm-textarea {
  width: 100%;
  min-height: 60px;
  margin-bottom: 15px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: TTNormsRegular, sans-serif;
  resize: vertical;
}
.confirm-buttons {
  display: flex;
  justify-content: center;
  gap: 15px;
}
.confirm-btn {
  padding: 8px 24px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-family: TTNormsMedium, sans-serif;
  font-size: 14px;
}
.confirm-btn.cancel {
  background: #e0e0e0;
  color: #333;
}
.confirm-btn.ok {
  background: #005eb8;
  color: #fff;
}
@media print {
  .dashboard {
    min-height: 10vh;
  }
}
</style>
